import * as Yup from "yup";

export const NumRegisterTeamInitialState = {
  registerPlayer: "",
};

export const NumRegisterTeamValidationSchema = Yup.object({
  registerPlayer: Yup.string().required("Este campo es requerido"),
});
